export default __webpack_public_path__ + "static/media/winners.0ea78ef6.svg";